

















































































































































































































import {Component, PropSync, Watch} from 'vue-property-decorator'
import {Action, Getter} from 'vuex-class';
import BaseFilter from '@/components/Filter/BaseFilter';
import {notifyWarning} from '@/utils/notify-helper';
import {PushDevicesFilter, PushMappsVersionItem, PushOsVersionItem} from "@/store/push/devices/types";
import {getTranslatedParams} from "@/utils/notify-utils";
import {beginningOfCurrentDay, currentDateEnd, dateFilter} from "@/utils/date-util";
import {FastDateDetailWings, DatePickerWings, SelectWings, InputWings} from "wings-ui-components";

@Component({
  components: {FastDateDetailWings, SelectWings, DatePickerWings, InputWings},
  filters: {dateFilter}
})
export default class PushDeviceFilter extends BaseFilter<PushDevicesFilter> {
  @PropSync('show') is_show!: boolean;

  @Action("getPushDevices") actionGetPushDevices: any;
  @Action("getPushApplications") actionGetPushApplications: any;
  @Action("getPushOS") actionGetPushOS: any;
  @Action("getPushOsVersions") actionGetPushOsVersions: any;
  @Action("getPushSdkVersions") actionGetPushSdkVersions: any;
  @Action("getPushMappsVersions") actionGetPushMappsVersions: any;
  @Action("getApplicationAttributes") actionGetApplicationAttributes: any;

  @Getter("pushOS") pushOSList: any;
  @Getter("pushOsVersions") pushOsVersionsList: any;
  @Getter("pushSdkVersions") pushSdkVersionsList: any;
  @Getter("pushMappsVersions") pushMappsVersionsList: any;
  @Getter("applicationAttributes") pushApplicationAttributes: any;
  @Getter("pushApplications") pushApplicationsList: any;

  private selectedAttributes: string[] = [];

  defaultFilter(): PushDevicesFilter {
    return {
      date_from: beginningOfCurrentDay(),
      date_to: currentDateEnd(),
      attr_device: {},
      os: undefined,
      os_version: undefined,
      page_number: 1
    };
  }

  created() {
    this.actionGetPushOS();
    this.actionGetPushSdkVersions();
    this.actionGetPushApplications();
  }

  async onFilteredAction() {
    const payload = {...this.filter, attr_device: JSON.stringify(this.filter.attr_device)};
    try {
      this.logObject = {
        action_page: this.$route.meta.msgKey,
        action: "Viewing",
        action_status: "success",
        object_type: "Devices",
        addititional_info: getTranslatedParams(this.filter)
      };
      const res = await this.actionGetPushDevices(payload);
      await this.actionLog(this.logObject);
      if (res.status == 204) {
        notifyWarning();
      }
    } catch (err) {
      this.actionLog({...this.logObject, action_status: 'failed'});
    }
  }

  getApplicationId(name?: string): number {
    const application = this.pushApplicationsList.find((item: any) => item.name === name);
    return application ? application.id : '';
  }

  unsetAttributeByName(name: string) {
    delete this.filter.attr_device?.[name];
    this.selectedAttributes = this.selectedAttributes.filter((item: string) => item !== name);
  }

  @Watch('filter.os')
  onFilterOsChanged(newVal: string) {
    this.filter = {...this.filter, os_version: undefined};
    if (newVal) {
      this.actionGetPushOsVersions({ os_filter: newVal });
    }
  }

  @Watch('filter.application', { immediate: false })
  onApplicationChanged(newVal: string) {
    this.filter = {...this.filter, app_version: undefined};
    if (newVal) {
      this.actionGetPushMappsVersions({ app_id: this.getApplicationId(newVal) });
      this.actionGetApplicationAttributes({ application_id: this.getApplicationId(newVal), filter: { owner: 'device' } });
    } else {
      this.selectedAttributes = [];
      this.filter.attr_device = {};
    }
  }

  @Watch('selectedAttributes', { immediate: true, deep: true })
  onSelectedAttributesChanged() {
    const updated: Record<string, string> = { ...this.filter.attr_device };

    this.selectedAttributes.forEach((name: string) => {
      if (!updated[name]) updated[name] = '';
    });

    Object.keys(updated).forEach(key => {
      if (!this.selectedAttributes.includes(key)) delete updated[key];
    });

    this.filter.attr_device = updated;
  }
}
